import { Route, Routes } from "react-router";
import AboutUs from "./AboutUs";
import AcademicFees from "./AcademicFees";
import AdmissionForm from "./AdmissionForm";
import AdmissionGuideline from "./AdmissionGuideline";
import AdmissionSuspension from "./AdmissionSuspension";
import ApplyAdmission from "./ApplyAdmission";
import Blog from "./Blog";
import BlogSingle from "./BlogSingle";
import ClassBook from "./ClassBook";
import ClassRoutine from "./ClassRoutine";
import ContactUs from "./ContactUs";
import ExamRoutine from "./ExamRoutine";
import Facilities from "./Facilities";
import Home from "./Home";
import NotFoundPage from "./NotFoundPage";
import NoticeBorad from "./NoticeBorad";
import StudentResults from "./StudentResults";
import WhyStudy from "./WhyStudy";

const RoutePage = ({ schoolInfo }) => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home schoolInfo={schoolInfo} />} />
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/whystudy" element={<WhyStudy />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/applyadmission" element={<ApplyAdmission />} />
        <Route path="/admissionguideline" element={<AdmissionGuideline />} />
        <Route path="/admissionform" element={<AdmissionForm />} />
        <Route path="/admissionsuspension" element={<AdmissionSuspension />} />
        <Route path="/academicfees" element={<AcademicFees />} />
        <Route path="/classbook" element={<ClassBook />} />
        <Route path="/classroutine" element={<ClassRoutine />} />
        <Route path="/examroutine" element={<ExamRoutine />} />
        <Route path="/noticeboard" element={<NoticeBorad />} />
        <Route path="/studentresults" element={<StudentResults />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogsingle" element={<BlogSingle />} />
        <Route path="/contactus" element={<ContactUs schoolInfo={schoolInfo} />} />
      </Routes>
    </>
  );
};

export default RoutePage;
